import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { emergencyContactsSchema } from '../../schemas/emergencyContactsSchema';
import { ControlButtons } from '../ControlButtons';
import { EmergencyContactInfo } from './EmergencyContactInfo';

export const EmergencyContacts = ({
	currContacts = {
		contacts: [
			{
				contactName: '',
				relationship: '',
				cellPhone: '',
				officePhone: '',
			},
		],
	},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, unregister, handleSubmit, formState } = useForm({
		resolver: yupResolver(emergencyContactsSchema),
		defaultValues: currContacts,
	});
	const [contacts, setContacts] = useState(currContacts.contacts);

	function addNewItem() {
		const newItem = {
			contactName: '',
			relationship: '',
			cellPhone: '',
			officePhone: '',
		};

		setContacts(previousInventory => [...previousInventory, newItem]);
	}

	const handleRemove = id => {
		setContacts([...contacts.slice(0, id), ...contacts.slice(id + 1)]);
	};

	function commitChange(item, idx) {
		const newContact = [...contacts];
		newContact[idx] = item;
		setContacts(newContact);
	}

	return (
		<Container className="component">
			<Container className="p-0 mt-5 mb-5 component">
				<h2 className="mb-4">Emergency Contacts</h2>

				{contacts.map((item, id) => (
					<div key={id}>
						<EmergencyContactInfo
							id={id}
							value={item}
							currItem={item}
							register={register}
							unregister={unregister}
							error={formState.errors}
							enableRemove={id === 0 ? false : true}
							handleRemove={handleRemove}
							commitChange={commitChange}
						/>
						{contacts.length > 1 && <hr />}
					</div>
				))}

				<Row>
					<Col
						className="mt-2 mr-3"
						style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button variant="outline-secondary" size="mg" onClick={addNewItem}>
							Add Contact
						</Button>
					</Col>
				</Row>
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={onSubmit}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
			/>
		</Container>
	);
};
